/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface CancelledAppointment { 
    beforeCancellationPeriod: boolean;
    isSicknessReason: boolean;
}
export const CancelledAppointment_beforeCancellationPeriod_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CancelledAppointment_isSicknessReason_Validators: ValidatorFn[] =
    [  Validators.required, ];


